module.exports = __webpack_public_path__ + "no.svg?fbcb566f0dea91234a3dd12a2b805441";